<template>
  <div>
    <div class="rounded-md bg-yellow-100 p-4 hidden">
      <div class="flex">
        <div class="shrink-0">
          <InformationCircleIcon class="h-5 w-5 text-yellow-600" aria-hidden="true" />
        </div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-sm text-yellow-700">{{ $t('disabled_signals_alert') }}</p>
          <p class="mt-3 text-sm md:ml-6 md:mt-0">
            <a href="#" class="whitespace-nowrap font-medium text-yellow-700 hover:text-yellow-600">
              {{ $t('signals') }}
              <span aria-hidden="true"> &rarr;</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {InformationCircleIcon} from "@heroicons/vue/20/solid";

export default {
  components: {
    InformationCircleIcon
  },
}
</script>